import type { IOption } from "@/interfaces";
import { computed } from "vue";
import { globali18n } from "@/i18n";

export default function useRepeatRuleLists() {
  const { t } = globali18n;

  const ORDER_LIST = computed<IOption[]>(() => {
    return [
      {
        value: 1,
        title: t("templates.rruleinput.first"),
      },
      {
        value: 2,
        title: t("templates.rruleinput.second"),
      },
      {
        value: 3,
        title: t("templates.rruleinput.third"),
      },
      {
        value: 4,
        title: t("templates.rruleinput.fourth"),
      },
      {
        value: -1,
        title: t("templates.rruleinput.last"),
      },
    ];
  });

  const DAYS_LIST = computed<IOption[]>(() => {
    return [
      { value: 0, title: t("calendar.days.monday") },
      { value: 1, title: t("calendar.days.tuesday") },
      { value: 2, title: t("calendar.days.wednesday") },
      { value: 3, title: t("calendar.days.thursday") },
      { value: 4, title: t("calendar.days.friday") },
      { value: 5, title: t("calendar.days.saturday") },
      { value: 6, title: t("calendar.days.sunday") },
    ];
  });

  return {
    ORDER_LIST,
    DAYS_LIST,
  };
}
